import React from 'react'
import Premium from '../../../../assets/premium/assistance.png'
import { theme } from '../../../../theme'

function PremiumAssistentIcon({ size = 1, color }) {
  return (
    <img
      alt={'Premium icon'}
      style={{
        filter:
          color === theme.colors.palette.slateGrey ? 'grayscale(100%)' : '',
        marginRight: `${20 * size}px`,
      }}
      width={32 * size}
      height={32 * size}
      src={Premium}
    />
  )
}

export default PremiumAssistentIcon
